import { render } from "./PartStatusDetail.vue?vue&type=template&id=295a11e0"
import script from "./PartStatusDetail.vue?vue&type=script&lang=js"
export * from "./PartStatusDetail.vue?vue&type=script&lang=js"
script.render = render

export default script